import React, { Component } from 'react';
import Footer from '../Landing/pages/components/footer';
import MyNav from '../Landing/components/NavBar';
import FAQComponent from './faq.js';
import translate from '../../translate';
import './index.css'

class Landing extends Component {
  constructor(props){
    super(props);
    this.state = {
      showTerms:this.props?.location?.state?.showTerms,
      showPrivacy:this.props?.location?.state?.showPrivacy,
      lan:localStorage.getItem('lan') ?localStorage.getItem('lan') :'es',
    }
    this.changeLan = this.changeLan.bind(this)
    this.footerRef = React.createRef();
  }

  changeLan(lan){
    this.setState({ text: translate[lan].Landing.Content, lan:lan})
  }

  componentDidMount(){
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }

  render() {
    return (
      <div id="faq" className={'backgroundLI'}>
        {/* <MyNav id="faq" data={this.props} selected="/" changeLan={(e)=>this.changeLan(e)} /> */}
        <FAQComponent lan={this.state.lan} showPrivacyModal={this.showPrivacyModal} />
        {/* <Footer lan={this.state.lan} showTerms={this.state.showTerms} showPrivacy={this.state.showPrivacy} /> */}
      </div>
    );
  }
}

export default Landing
